// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.treeSelectWrapper__HLOvQ {
  position: relative;
}

.inputWrapper__kyUEY {
  position: relative;
}

.label__sRxjd {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.05em;
  color: var(--title-inputs-sections-title);
  margin-bottom: 7px;
  text-transform: uppercase;
  display: block;
}

.required__eh08O:after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}

.treeSelectInput__pcBZ7 {
  font-family: "Roboto", sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
  color: var(--inputs-filled-text);
  width: 100%;
  height: 100%;
  padding: 10px 25px 9px 15px;
  border: 1px solid var(--inputs-filled-stroke);
  border-radius: 5px;
  cursor: pointer;
  outline: none;
  text-overflow: ellipsis;
  background: var(--inputs-default-surface-default);
}
.treeSelectInput__pcBZ7:active {
  border: 1px solid var(--inputs-focus-stroke);
}
.treeSelectInput__pcBZ7:focus-visible {
  border: 1px solid var(--inputs-focus-stroke);
}
.treeSelectInput__pcBZ7::placeholder {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-default-placeholder);
  text-transform: none;
}

.headerTreeselectInput__q1DLJ {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  background-color: transparent;
  border: none;
  width: 240px;
}
.headerTreeselectInput__q1DLJ:active {
  border: none;
}
.headerTreeselectInput__q1DLJ:focus-visible {
  border: none;
}
@media (max-width: 950px) {
  .headerTreeselectInput__q1DLJ {
    width: 200px;
  }
}

.headerTreeComponent__tdKYt .rc-tree-node-content-wrapper {
  font-size: 10px !important;
  line-height: 10px !important;
  text-transform: uppercase;
}

.inputArrow__ISBBB {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
}

.treeWrapper__ExOIf {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  background-color: var(--inputs-filled-filled-surface);
  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05) !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  z-index: 3;
  overflow-y: auto;
}
.treeWrapper__ExOIf::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.treeWrapper__ExOIf::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.treeWrapper__ExOIf::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.treeWrapper__ExOIf::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.treeComponent__MHu6l .rc-tree-treenode {
  display: flex;
  align-items: center;
}
.treeComponent__MHu6l .rc-tree-treenode:not(.rc-tree-treenode-disabled) .rc-tree-node-content-wrapper:hover {
  font-weight: 500;
  color: var(--inputs-filled-text);
}
.treeComponent__MHu6l .rc-tree-treenode:not(:last-child) .rc-tree-node-content-wrapper {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.treeComponent__MHu6l .rc-tree-treenode.rc-tree-treenode-selected .rc-tree-node-content-wrapper {
  font-weight: 600;
  color: var(--inputs-filled-text);
  background-color: transparent;
  box-shadow: none;
}
.treeComponent__MHu6l .rc-tree-treenode.filter-node .rc-tree-node-content-wrapper {
  color: var(--inputs-focus-stroke) !important;
}
.treeComponent__MHu6l .rc-tree-treenode span.rc-tree-switcher {
  width: 20px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: none;
}
.treeComponent__MHu6l .rc-tree-treenode .rc-tree-switcher_open {
  transform: rotate(180deg);
}
.treeComponent__MHu6l .rc-tree-treenode .rc-tree-node-content-wrapper {
  font-size: 11px;
  line-height: 12px;
  color: var(--inputs-focus-text);
  width: 100%;
  height: auto;
  display: block;
  margin-right: 17px;
  padding-top: 16px;
  padding-bottom: 12px;
  overflow: hidden;
}
.treeComponent__MHu6l .rc-tree-treenode .rc-tree-node-content-wrapper .rc-tree-title {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.treeComponent__MHu6l .rc-tree-treenode.rc-tree-treenode-disabled .rc-tree-node-content-wrapper {
  color: var(--inputs-disable-text);
  cursor: not-allowed;
}
.treeComponent__MHu6l .rc-tree-switcher-noop {
  opacity: 0;
}

.noDataFound__wueRi {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--tables-title-text);
  width: 100%;
  height: 38px;
}

.helperText__rjx3e {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-stroke);
  margin-top: 4px;
  min-height: 11px;
}`, "",{"version":3,"sources":["webpack://./../src/components/uikit/TreeSelect/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yCAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAzEF;;AA6EE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AA1EJ;;AA8EA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,6CAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,iDAAA;AA3EF;AA6EE;EACE,4CAAA;AA3EJ;AA8EE;EACE,4CAAA;AA5EJ;AA+EE;EACE,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;EACA,oBAAA;AA7EJ;;AAiFA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;AA9EF;AAgFE;EACE,YAAA;AA9EJ;AAiFE;EACE,YAAA;AA/EJ;AAkFE;EAhBF;IAiBI,YAAA;EA/EF;AACF;;AAoFI;EACE,0BAAA;EACA,4BAAA;EACA,yBAAA;AAjFN;;AAsFA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AAnFF;;AAsFA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,qDAAA;EACA,4DAAA;EACA,mDAAA;EACA,UAAA;EACA,gBAAA;AAnFF;AA7EE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA+EJ;AA5EE;EACE,+BAAA;EACA,kBAAA;AA8EJ;AA3EE;EACE,8BAAA;EACA,kBAAA;AA6EJ;AA1EE;EACE,gBAAA;EACA,kBAAA;AA4EJ;;AAwEI;EACE,aAAA;EACA,mBAAA;AArEN;AAyEU;EACE,gBAAA;EACA,gCAAA;AAvEZ;AA6EQ;EACE,yDAAA;AA3EV;AAgFQ;EACE,gBAAA;EACA,gCAAA;EACA,6BAAA;EACA,gBAAA;AA9EV;AAmFQ;EACE,4CAAA;AAjFV;AAqFM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAnFR;AAsFM;EACE,yBAAA;AApFR;AAuFM;EACE,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AArFR;AAuFQ;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AArFV;AAyFM;EACE,iCAAA;EACA,mBAAA;AAvFR;AA2FI;EACE,UAAA;AAzFN;;AA8FA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;AA3FF;;AA8FA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AA3FF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.treeSelectWrapper {\n  position: relative;\n}\n\n.inputWrapper {\n  position: relative;\n}\n\n.label {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  letter-spacing: 0.05em;\n  color: var(--title-inputs-sections-title);\n  margin-bottom: 7px;\n  text-transform: uppercase;\n  display: block;\n}\n\n.required {\n  &:after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-text-helper);\n    margin-left: 4px;\n  }\n}\n\n.treeSelectInput {\n  font-family: 'Roboto', sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 12px;\n  color: var(--inputs-filled-text);\n  width: 100%;\n  height: 100%;\n  padding: 10px 25px 9px 15px;\n  border: 1px solid var(--inputs-filled-stroke);\n  border-radius: 5px;\n  cursor: pointer;\n  outline: none;\n  text-overflow: ellipsis;\n  background: var(--inputs-default-surface-default);\n\n  &:active {\n    border: 1px solid var(--inputs-focus-stroke);\n  }\n\n  &:focus-visible {\n    border: 1px solid var(--inputs-focus-stroke);\n  }\n\n  &::placeholder {\n    font-family: 'Roboto', sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 12px;\n    color: var(--inputs-default-placeholder);\n    text-transform: none;\n  }\n}\n\n.headerTreeselectInput {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  background-color: transparent;\n  border: none;\n  width: 240px;\n\n  &:active {\n    border: none;\n  }\n\n  &:focus-visible {\n    border: none;\n  }\n\n  @media (max-width: 950px) {\n    width: 200px;\n  }\n}\n\n.headerTreeComponent {\n  :global {\n    .rc-tree-node-content-wrapper {\n      font-size: 10px !important;\n      line-height: 10px !important;\n      text-transform: uppercase;\n    }\n  }\n}\n\n.inputArrow {\n  position: absolute;\n  top: 50%;\n  right: 16px;\n  transform: translateY(-50%);\n}\n\n.treeWrapper {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 200px;\n  background-color: var(--inputs-filled-filled-surface);\n  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05) !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  z-index: 3;\n  overflow-y: auto;\n  @include scrollBar;\n}\n\n.treeComponent {\n  :global {\n    .rc-tree-treenode {\n      display: flex;\n      align-items: center;\n\n      &:not(.rc-tree-treenode-disabled) {\n        .rc-tree-node-content-wrapper {\n          &:hover {\n            font-weight: 500;\n            color: var(--inputs-filled-text);\n          }\n        }\n      }\n\n      &:not(:last-child) {\n        .rc-tree-node-content-wrapper {\n          border-bottom: 1px solid var(--tables-primary-row-stroke);\n        }\n      }\n\n      &.rc-tree-treenode-selected {\n        .rc-tree-node-content-wrapper {\n          font-weight: 600;\n          color: var(--inputs-filled-text);\n          background-color: transparent;\n          box-shadow: none;\n        }\n      }\n\n      &.filter-node {\n        .rc-tree-node-content-wrapper {\n          color: var(--inputs-focus-stroke) !important;\n        }\n      }\n\n      span.rc-tree-switcher {\n        width: 20px;\n        height: 38px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-image: none;\n      }\n\n      .rc-tree-switcher_open {\n        transform: rotate(180deg);\n      }\n\n      .rc-tree-node-content-wrapper {\n        font-size: 11px;\n        line-height: 12px;\n        color: var(--inputs-focus-text);\n        width: 100%;\n        height: auto;\n        display: block;\n        margin-right: 17px;\n        padding-top: 16px;\n        padding-bottom: 12px;\n        overflow: hidden;\n\n        .rc-tree-title {\n          width: 100%;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n      }\n\n      &.rc-tree-treenode-disabled .rc-tree-node-content-wrapper {\n        color: var(--inputs-disable-text);\n        cursor: not-allowed;\n      }\n    }\n\n    .rc-tree-switcher-noop {\n      opacity: 0;\n    }\n  }\n}\n\n.noDataFound {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--tables-title-text);\n  width: 100%;\n  height: 38px;\n}\n\n.helperText {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-error-stroke);\n  margin-top: 4px;\n  min-height: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"treeSelectWrapper": `treeSelectWrapper__HLOvQ`,
	"inputWrapper": `inputWrapper__kyUEY`,
	"label": `label__sRxjd`,
	"required": `required__eh08O`,
	"treeSelectInput": `treeSelectInput__pcBZ7`,
	"headerTreeselectInput": `headerTreeselectInput__q1DLJ`,
	"headerTreeComponent": `headerTreeComponent__tdKYt`,
	"inputArrow": `inputArrow__ISBBB`,
	"treeWrapper": `treeWrapper__ExOIf`,
	"treeComponent": `treeComponent__MHu6l`,
	"noDataFound": `noDataFound__wueRi`,
	"helperText": `helperText__rjx3e`
};
module.exports = ___CSS_LOADER_EXPORT___;
